import { create } from "zustand";
import { ObjectType } from "pages/admin/objectsAndClients/objects/types";

export type VolumeConfirmationStoreState = {
  list: { isLoaded: boolean; data: ObjectType[] };
  setList: (
    update:
      | { isLoaded: boolean; data: ObjectType[] }
      | ((state: {
          isLoaded: boolean;
          data: ObjectType[];
        }) => { isLoaded: boolean; data: ObjectType[] })
  ) => void;
  isPostInProcess: boolean;
  setIsPostInProcess: (isPostInProcess: boolean) => void;
  selectedObjectIndex: number;
  setSelectedObjectIndex: (
    update: number | ((state: number) => number)
  ) => void;
  isError: boolean;
  setIsError: (isError: boolean) => void;
};

const useVolumeConfirmationStore = create<VolumeConfirmationStoreState>(
  (set) => ({
    list: {
      isLoaded: false,
      data: [],
    },
    setList: (update) =>
      set((state) => ({
        list: typeof update === "function" ? update(state.list) : update,
      })),
    isPostInProcess: false,
    setIsPostInProcess: (isPostInProcess) => set({ isPostInProcess }),
    selectedObjectIndex: 0, // начальное значение (можете задать другое)
    setSelectedObjectIndex: (update) =>
      set((state) => ({
        selectedObjectIndex:
          typeof update === "function"
            ? update(state.selectedObjectIndex)
            : update,
      })),
    isError: false,
    setIsError: (isError) => set({ isError }),
  })
);

export default useVolumeConfirmationStore;
